import { Link, NavLink } from "react-router-dom";
import { Phone, MessageCircle, MapPin } from "lucide-react";
import Logo from "./Logo";
import { BUSINESS, NAV_LINKS, SERVICES, waLink } from "../lib/constants";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-gold/20 bg-[#0A0908]">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Logo />
          <p className="mt-5 text-sm leading-relaxed text-stone-400">{BUSINESS.tagline}</p>
          <p className="mt-3 flex items-start gap-2 text-sm text-stone-400">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
            {BUSINESS.address}
          </p>
        </div>

        <div>
          <h4 className="eyebrow">Explore</h4>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <NavLink
                  to={l.path}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-sm text-stone-300 transition-colors hover:text-amber-300"
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="eyebrow">Services</h4>
          <ul className="mt-5 space-y-3">
            {SERVICES.slice(0, 5).map((s) => (
              <li key={s.slug}>
                <Link
                  to="/services"
                  data-testid={`footer-service-${s.slug}`}
                  className="text-sm text-stone-300 transition-colors hover:text-amber-300"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="eyebrow">Get in Touch</h4>
          <div className="mt-5 flex flex-col gap-3">
            <a
              href={BUSINESS.phoneHref}
              data-testid="footer-call-btn"
              className="flex items-center gap-3 text-sm text-stone-300 transition-colors hover:text-amber-300"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-gold/30">
                <Phone className="h-4 w-4 text-gold" />
              </span>
              {BUSINESS.phone}
            </a>
            <a
              href={waLink("Hello Jaiswal Tent House! I would like to enquire about your services.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-btn"
              className="flex items-center gap-3 text-sm text-stone-300 transition-colors hover:text-amber-300"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-full border border-gold/30">
                <MessageCircle className="h-4 w-4 text-gold" />
              </span>
              {BUSINESS.whatsapp} <span className="text-xs text-stone-500">(WhatsApp)</span>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-gold/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-5 py-6 text-xs text-stone-500 sm:flex-row sm:px-8">
          <p>© {year} {BUSINESS.name} · Bilaspur, Chhattisgarh</p>
          <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-amber-300">
            Owner's Inbox
          </Link>
        </div>
      </div>
    </footer>
  );
}
